"use client";
import "./homeAuthority.css";
import { motion } from "framer-motion";
import { useTranslations } from "next-intl";
import { fadeUp, staggerContainer, staggerItem } from "@lib/motion";

const CARDS = ["evaluated", "factors", "independent", "members"] as const;

export default function HomeAuthority() {
  const t = useTranslations("home.authority");

  return (
    <div id="home-authority" className="home-authority">
      <motion.div className="home-authority-header" {...fadeUp()}>
        <p className="home-section-label">{t("label")}</p>
        <h2>{t("headline")}</h2>
      </motion.div>

      <motion.div className="home-authority-grid" {...staggerContainer(0.3)}>
        {CARDS.map((key) => (
          <motion.div key={key} className="home-authority-card" variants={staggerItem}>
            <p className="home-authority-stat">{t(`cards.${key}.stat`)}</p>
            <p className="home-authority-card-title">{t(`cards.${key}.title`)}</p>
            <p className="home-authority-card-desc">{t(`cards.${key}.desc`)}</p>
          </motion.div>
        ))}
      </motion.div>
    </div>
  );
}
